import { FC } from 'react';
import { StyledNGGradientSeparator } from './NGGradientSeparator.styles';
import { INGGradientSeparator } from './NGGradientSeparator.type';

const NGGradientSeparator: FC<INGGradientSeparator> = ({ direction, ...otherProps }) => {
	return <StyledNGGradientSeparator direction={direction} {...otherProps} />;
};

export { NGGradientSeparator };
